// Update contents object below
const contents = {
  header: 'Lenovo + Intel', //update with your client name

  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: '',
    copy: ''
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption: '43 hectares of greenhouse farming space at Perfection Two Wells'
      },
      {
        class: 'photo2',
        caption: 'A cluster of Kumatoes® on the vine at Perfection Two Wells'
      },
      {
        class: 'photo3',
        caption: 'Crop of Perfection Fresh Qukes® baby cucumbers at Perfection Two Wells'
      },
      { class: 'photo4', caption: '' }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href: 'https://www.courageousstudios.com/', //where the cta button click drives to
    copy: 'www.courageousstudios.com/' //tooltip content
  }
};

export default contents;
